module.exports = __webpack_public_path__ + "img/discount-red.ccbcfaee.png";